import axios from '@/axios'
import helper from './helper'

export default {
  checkPrepaidEntry(voucher) {
    return axios
      .post(`/event-entries/check-prepaid-entry/${ voucher }`, {})
      .then((response) => {
        return response.data
      })
  },
  registrationsTotal(event, entrytype, category, gender) {
    return axios
      .post(`/event-entries/registrations-total/${ event }`, {
        entrytype: entrytype,
        category: category,
        gender: gender
      })
      .then((response) => {
        return response.data
      })
  },
  alreadyRegistered(eventId, dependant) {
    return axios
      .post(`/event-entries/event-registered/${ eventId }`, {
        dependant: dependant
      })
      .then((response) => {
        return response.data
      })
  },
  entryForEvent(eventId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/event-entries/entry-for-event/${ eventId }`)
        .then((response) => {
          return resolve(response.data)
        })
        .catch((error) => {
          return reject(error)
        })
    })
  },
  entriesForEvent(eventId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/event-entries/entries-for-event/${ eventId }`)
        .then((response) => {
          return resolve(response.data)
        })
        .catch((error) => {
          return reject(error)
        })
    })
  },
  checkTeamNameExists(event, teamname) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/event-entries/check-team-name/${ event }`, {
          teamname: teamname
        })
        .then((response) => {
          return resolve(response.data)
        })
        .catch((error) => {
          return reject(error.data)
        })
    })
  },
  joinWaitingList(event, entry) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/event-entries/join-waiting-list/${ event }`, entry)
        .then((response) => {
          return resolve(response.data)
        })
        .catch((error) => {
          return reject(error.data)
        })
    })
  },
  enterEvent(event, entry) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/event-entries/enter-event/${ event }`, entry)
        .then((response) => {
          return resolve(response.data)
        })
        .catch((error) => {
          return reject(error.data)
        })
    })
  },
  getEventEntry(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/event-entries/${ id }`)
        .then((response) => {
          return resolve(response.data)
        })
        .catch((error) => {
          return reject(error.data)
        })
    })
  },
  changeCaptaincy(entryId, entry) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/event-entries/change-captaincy/${ entryId }`, entry)
        .then((response) => {
          return resolve(response.data)
        })
        .catch((error) => {
          return reject(error.data)
        })
    })
  },
  findByTeamName(eventId, teamname) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/event-entries/findbyteamname/${ eventId }/${ teamname }`)
        .then((response) => {
          return resolve(response.data)
        })
        .catch((error) => {
          return reject(error.data)
        })
    })
  },
  findByTeamCaptain(eventId, captainsEmail) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/event-entries/findbyteamcaptain/${ eventId }/${ captainsEmail }`)
        .then((response) => {
          return resolve(response.data)
        })
        .catch((error) => {
          return reject(error.data)
        })
    })
  },
  updateAffiliateTeam(entryId, affiliateTeamId) {
    return helper.put(`/event-entries/affiliateteam/${ entryId }`, {
      affiliateteam: affiliateTeamId
    })
  },
  updateEntry(entry) {
    return helper.put(`/event-entries/${ entry._id }`, entry)
  },
  getAffiliateTeamMembers(affiliateTeamId) {
    return helper.get(`/event-entries/affiliateteam/${ affiliateTeamId }`)
  },
  getAvailableAffiliateTeamMembers(eventId, category) {
    return helper.post(`/event-entries/affiliateteam/available/${ eventId }`, {
      category: category
    })
  },
  updatePop(entryId, url) {
    return helper.post(`/event-entries/update-pop/${ entryId }`, {
      url: url
    })
  },
  sendConfirmationMail(entryId) {
    return helper.post(`/event-entries/send-confirmation-mail/${ entryId }`, {})
  }
}
